import { render, staticRenderFns } from "./FormProcedimentos.vue?vue&type=template&id=83c9fc94&"
import script from "./FormProcedimentos.vue?vue&type=script&lang=js&"
export * from "./FormProcedimentos.vue?vue&type=script&lang=js&"
import style0 from "./FormProcedimentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports